export default __webpack_public_path__ + "images/SpeakersPhotos/Alberto_Turégano.jpg?f4eb2d30";